import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billreports',
  templateUrl: './billreports.component.html',
  styleUrls: ['./billreports.component.scss']
})
export class BillreportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
